import React from 'react'
import { decode } from 'html-entities'
export const SingleSpecCategoryList = ({ category }) => {
    const [title, features] = category
    return (
        <div className="table__group" key={title}>
            <h3 className="h4 u-margin-bottom-small">{title}</h3>
            <div className="table">
                {Object.entries(features).map(([name, desc]) => (
                    <div key={name}>
                        <div>{decode(name.toString())}</div>
                        <div>{decode(desc.toString())}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}
